<template lang="html">
  <!-- Over importing warning. -->
  <div class="mt-5 alert alert-danger">
    <div v-if="$store.state.imageImportLimit == maxImagesPerShow" class="mt-1">
      <!-- Premium or grandfathered account holder.-->
      <p>
        The maximum is
        {{ $store.state.imageImportLimit }}
        images per show. You selected {{ selectedImagesTotal }} images.
      </p>
    </div>
    <div v-else class="mt-1">
      <p>
        Your <strong>{{ $store.getters.user_plan.name }}</strong> account
        enables
        {{ $store.state.imageImportLimit }}
        images per show.
      </p>
      <p>
        You selected {{ selectedImagesTotal }} images.
        <b-link :to="{ name: 'upgrade_view' }" target="_blank">
          View account details <v-icon name="external-link-alt" />
        </b-link>
      </p>
    </div>
    <p class="mb-1">
      Click
      <b-link @click="selectImages">
        Import images <v-icon name="images" />
      </b-link>
      to make different selections, or continue with the first
      {{ $store.state.imageImportLimit }} images.
    </p>
  </div>
</template>

<script>
import { maxImagesPerShow } from "@/defaults";
export default {
  name: "ImageLimitImportWarning",
  props: {
    selectedImagesTotal: {
      type: Number,
      default: () => 0
    }
  },
  computed: {
    maxImagesPerShow() {
      return maxImagesPerShow;
    }
  },
  methods: {
    selectImages() {
      this.$emit("select");
    }
  }
};
</script>

<style lang="css" scoped></style>
